import React, { useEffect, useRef } from 'react'
import { useReactToPrint } from 'react-to-print';
import moment from 'moment'
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import QRCode from 'qrcode.react'
import '../../../../style/ksrtc/counterEticket.scss'
import kimage from '../../../../assets/logoCargoPrintEnglish.png';
import numberToWords from 'number-to-words'

const DemurrageReceiptPrint = ({  isPrint = false, closeTab = false, demPrintData }) => {
  const componentRef = useRef();
  const LoginId = sessionStorage.getItem('LoginId')
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect(() => {
    if (isPrint && Object.keys(demPrintData).length > 0) {
      handlePrint()
      closeTab && closeTab()
    }
  }, [isPrint, demPrintData]);
  const capitalizeFirstLetter = (str) => {
    return str.split(' ').map(word => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');
  };

  const convertNumberToWordsWithDecimal = (amount) => {
    const [wholeNumber, decimalPart] = amount.toFixed(2).split('.'); // Ensure 2 decimal places and split

    let wordRepresentation = numberToWords.toWords(parseInt(wholeNumber)) + ' rupees';
    if (decimalPart && parseInt(decimalPart) > 0) {
      wordRepresentation += ` and ${numberToWords.toWords(parseInt(decimalPart))} paise`;
    }
    return wordRepresentation + " only";
  };

  // Mocked Date and Time for demonstration
  const printDateTime = moment(new Date()).format('DD-MMM-YYYY, HH:mm:ss');
  
  const numberInWord = convertNumberToWordsWithDecimal(demPrintData?.[0]?.TotalAmount === undefined ? 0 : demPrintData?.[0]?.TotalAmount);
  // const numberInWord = convertNumberToWordsWithDecimal(7.2);
  const numInWordCapitalized = capitalizeFirstLetter(numberInWord);
  return (
    <>
      <div style={{
        display: "none",
        padding: '0px',
        height: '2722px',
        width: '100%',
      }}>
        <div ref={componentRef} style={{ width: '100%', margin: '0px', padding: '30px' }}>
          <div style={{
            padding: '0px 12px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            gap:'10px' // Added to allow absolute positioning of child elements
          }}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
              <img
                src={kimage}
                alt="Logo"
                style={{
                  height: "100.55px",
                  width: "200px",
                }}
              />
              <div style={{
                position: 'absolute',
                top: '0',
                right: '0',
                padding: '5px 10px',
                fontSize: '12px',
                fontWeight: '500',
                color: '#000',
                textAlign:'right',
                lineHeight:'14.52px'
              }}>
                Print & Date Time <br />
                {printDateTime}
              </div>
            </div>
          </div>
          <div style={{
            padding:'2.5px 16px',
            textAlign: 'center',
            fontSize: '14px',
            fontWeight: 400,
            color: '#000',
            lineHeight:'16.94px'
          }}>
           KSRTC LOGISTICS: {demPrintData?.[0]?.DeliveryCounter}
          </div>
          <div style={{
            padding:'2.5px 16px',
            textAlign: 'center',
            fontSize: '12px',
            fontWeight: 400,
            color: '#000',
            lineHeight:'14.52px'
          }}>
            PARCEL SERVICES SECTION
          </div>
          <div style={{
            padding:'2.5px 16px',
            textAlign: 'center',
            fontSize: '12px',
            fontWeight: 400,
            color: '#000',
            lineHeight:'14.52px'
          }}>
           DEMURRAGE RECEIPT {demPrintData?.[0]?.DemurrageInvoiceNo}
          </div>
          <div style={{
            padding:'2.5px 16px',
            textAlign: 'center',
            fontSize: '12px',
            fontWeight: 400,
            color: '#000',
            lineHeight:'14.52px'
          }}>
             {demPrintData?.[0]?.ReceiverGSTN && `GST No ${demPrintData?.[0]?.ReceiverGSTN}`}
          </div>
          <div style={{
          width:'576px',          // Set the width to 600px
          margin: '0 auto',        // Center the div horizontally
          padding:'2.5px 16px',
          textAlign: 'left',       // Align the text to the left
          fontSize: '14px',
          fontWeight: 400,
          color: '#000',
          lineHeight:'20px'
          }}>
          Received Rs. {demPrintData?.[0]?.TotalAmount}/- ({numInWordCapitalized}) from {demPrintData?.[0]?.ReceivedBy} ({demPrintData?.[0]?.ReceiverContactNo}) towards demurrage charges for AWB No. {demPrintData?.[0]?.AWBNo} from {demPrintData?.[0]?.FromDate} to {demPrintData?.[0]?.ToDate}
          </div>
          <div style={{
              width:'576px',          // Set the width to 600px
              margin: '0 auto',        // Center the div horizontally
              padding:'2.5px 16px',
              textAlign: 'left',       // Align the text to the left
              fontSize: '14px',
              fontWeight: 400,
              color: '#000',
              lineHeight:'20px'
          }}>
          For KSRTC
          </div>
          <div style={{
            width: '576px',          // Same width as the above divs
            margin: '10px auto',     // Center horizontally and add some spacing
            borderTop: '1px dashed #000'  // Dashed top border
          }}></div>
           <div style={{
              width:'576px',          // Set the width to 600px
              margin: '0 auto',        // Center the div horizontally
              padding:'2.5px 16px',
              textAlign: 'left',       // Align the text to the left
              fontSize: '12px',
              fontWeight: 400,
              color: '#000',
              lineHeight:'20px'
          }}>
          For Any Complaint Suggestions. Please Call Toll Free No: 18002085533,
          </div>
          <div style={{
              width:'576px',          // Set the width to 600px
              margin: '0 auto',        // Center the div horizontally
              padding:'2.5px 16px',
              textAlign: 'left',       // Align the text to the left
              fontSize: '12px',
              fontWeight: 400,
              color: '#000',
              lineHeight:'20px'
          }}>
         Email : ksrtclogistics@ksrtc.org
          </div>
          {/* Rest of your code */}
        </div>
      </div>
    </>
  )
}


export default DemurrageReceiptPrint